import {
  Banner,
  BannerButton,
  BannerDescription,
  BannerTitle,
} from "@prismicio/editor-ui"
import { useLayoutEffect } from "react"
import { Link } from "react-router-dom"

import { useSubscriptionQuery } from "../../settings/billing/useSubscription"
import { getBaseRepositoryUrl, getRepositoryName } from "../routing"
import { getCurrentMonthYear } from "./getCurrentMonthYear"
import { useGlobalBanner } from "./GlobalBanner"

export function usePaymentFailedBanner() {
  const { showBanner } = useGlobalBanner()

  const { data: subscription } = useSubscriptionQuery()

  useLayoutEffect(() => {
    if (subscription.paymentFailed) {
      showBanner({
        id: `payment-failed-${subscription.id}-${getCurrentMonthYear()}`,
        render: ({ onClose }) => <PaymentFailedBanner onClose={onClose} />,
      })
    }
  }, [subscription, showBanner])
}

interface PaymentFailedBannerProps {
  onClose: () => void
}

function PaymentFailedBanner(props: PaymentFailedBannerProps) {
  const { onClose } = props

  return (
    <Banner color="warn" iconName="alert" onClose={onClose}>
      <BannerTitle>Payment failed</BannerTitle>
      <BannerDescription>
        We couldn't charge your payment method. To avoid disruption, update your
        payment details.
      </BannerDescription>
      <UpdateLinkButton />
    </Banner>
  )
}

function UpdateLinkButton() {
  const repositoryId = getRepositoryName()
  const baseRepoUrl = getBaseRepositoryUrl(repositoryId)

  return (
    <BannerButton asChild>
      <Link to={`${baseRepoUrl}/settings/plan`}>Update →</Link>
    </BannerButton>
  )
}
